import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftColorful = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 18,
	fill: "none",
	viewBox: "0 0 17 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDE21C",
			d: "M7.50082 0.468722L0.942626 4.05719C0.361423 4.37521 0 4.98496 0 5.64748V12.0059C0 12.6457 0.337206 13.2381 0.887299 13.5647L7.42638 17.4472C7.99983 17.7877 8.71392 17.7858 9.28557 17.4423L15.7363 13.5661C16.2817 13.2383 16.6154 12.6486 16.6154 12.0122V5.46906C16.6154 4.79799 16.2447 4.18182 15.6518 3.86747L9.22015 0.457413C8.68159 0.171866 8.03557 0.176116 7.50082 0.468722Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B97F0F",
			d: "M16.1704 4.28027C16.4525 4.60477 16.6156 5.02436 16.6157 5.46875V12.0127C16.6156 12.6489 16.2821 13.2387 15.7368 13.5664L9.28662 17.4424C8.96073 17.6382 8.5882 17.7217 8.22217 17.6953V9L16.1704 4.28027Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#A72220",
			d: "M10.7028 6.72354L3.46094 2.59001L5.59325 1.38477L12.7379 5.46048C13.2091 5.72929 13.5 6.23014 13.5 6.77264V14.8284C13.5 14.9348 13.444 15.0334 13.3527 15.0879L11.9215 15.9417C11.7202 16.0619 11.4646 15.9168 11.4646 15.6823V8.03553C11.4646 7.49316 11.1739 6.99241 10.7028 6.72354Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBA81A",
			d: "M8.22168 9.00049V17.6958C7.94574 17.6759 7.67322 17.5941 7.42676 17.4478L0.887695 13.5649C0.337602 13.2383 0 12.6461 0 12.0063V5.64795C5.44766e-06 5.20508 0.161694 4.78575 0.442383 4.46143L8.22168 9.00049Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DF3131",
			d: "M6.25812 6.72354L13.5 2.59001L11.3677 1.38477L4.22306 5.46048C3.75184 5.72929 3.46094 6.23014 3.46094 6.77264V14.8284C3.46094 14.9348 3.5169 15.0334 3.60827 15.0879L5.03939 15.9417C5.24078 16.0619 5.49632 15.9168 5.49632 15.6823V8.03553C5.49632 7.49316 5.78708 6.99241 6.25812 6.72354Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FE6160",
			d: "M4.66402 0.348975C4.81295 0.162812 5.09063 0.147433 5.25921 0.31601L8.0082 3.065C8.1411 3.19791 8.0339 3.42413 7.84687 3.40543L3.36802 2.95754C3.05245 2.92599 2.89736 2.5573 3.09547 2.30965L4.66402 0.348975Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D33338",
			d: "M5.54605 1.87257C5.67132 1.78558 5.83515 1.77739 5.96847 1.85146L7.06632 2.46138C7.25195 2.56451 7.17012 2.84768 6.9581 2.8359L5.5275 2.75642C5.14752 2.73531 5.00894 2.24557 5.32153 2.02849L5.54605 1.87257Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FE6160",
			d: "M13.1122 5.90385C12.9926 6.17681 12.6623 6.28521 12.4043 6.13621L8.21607 3.71816C8.05329 3.62418 8.09829 3.37792 8.28378 3.34758L13.7836 2.448C14.1748 2.38401 14.4813 2.77899 14.3222 3.1421L13.1122 5.90385Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D33338",
			d: "M11.3671 4.38217C11.2475 4.65512 10.9172 4.76353 10.6591 4.61453L9.46687 3.92617C9.3041 3.83219 9.3491 3.58593 9.53459 3.55559L10.9908 3.31739C11.3821 3.2534 11.6886 3.64839 11.5295 4.01149L11.3671 4.38217Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.30745,
			height: 2.30745,
			x: 7.59814,
			y: 2.30737,
			fill: "#FE6160",
			rx: .7,
			transform: "rotate(23.6039 7.59814 2.30737)"
		})
	]
});
const ForwardRef = forwardRef(SvgGiftColorful);
export default ForwardRef;
